<template>
  <div class="pjmain">
    <div class="content" v-cloak>
      <div class="pjxqtitle" v-if="type == 1">
        <div>
          {{ tsxq.complaintType }}
          <button class="dpj">{{ tsxq.status }}</button>
        </div>
        <p>{{ tsxq.address }}</p>
      </div>
      <div class="bxqk mt10" v-if="type == 1">
        <p>{{ tsxq.content }}</p>
        <van-image
          v-for="(item, index) in tsxq.attachs"
          width="100"
          height="100"
          fit="contain"
          :src="imgIp + item"
          @click="preview(tsxq.attachs)"
        />
      </div>
      <div class="bxqk mt10" v-if="type == 1&&tsxq.complaintResult">
        <p>办结结果</p>
        <p class="sx">办理意见：
          <span class="zhi">{{tsxq.complaintResult.result}}</span>
        </p>
        <div v-if='tsxq.complaintResult.attachs'>
        <van-image
          v-for="(item, index) in tsxq.complaintResult.attachs"
          width="100"
          height="100"
          fit="contain"
          :src="imgIp + item.webUrl"
          @click="preview(tsxq.complaintResult.attachs,2)"
        />

        </div>
        <div v-else style="color:grey">
          暂无结果图片..
        </div>
      </div>
      <div class="pjxqtitle" v-if="type == 2">
        <div>
          {{ bxxq.repairType }} <button class="dpj">{{ bxxq.status }}</button>
        </div>
        <p>紧急程度：{{ bxxq.repairLevel }}</p>
        <p></p>
        <p>{{ bxxq.address }}</p>
        <p>期望上门时间：{{ bxxq.planCompTime }}</p>
        <p>预约上门时间：{{ bxxq.yyRepairTime }}</p>
      </div>
      <div class="bxqk mt10" v-if="type == 2">
        <p>{{ bxxq.content }}</p>
        <van-image
          v-for="(item, index) in bxxq.attachs"
          width="100"
          height="100"
          fit="contain"
          :src="imgIp + item"
          @click="preview(bxxq.attachs)"
        />
      </div>

      <div v-if="isPingjia" class="pj-dv">
        评价信息
        <van-cell-group>
          <van-field name="radio" label="服务评价" required input-align="right">
            <template #input>
              <van-radio-group
                v-model="xzlist.level"
                direction="horizontal"
                @change="changeType"
              >
                <van-radio :name="item.id" v-for="(item, i) in levels">{{
                  item.text
                }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <van-field
            v-model="xzlist.content"
            label="反馈"
            placeholder="反馈"
            input-align="right"
            type="textarea"
          ></van-field>
        </van-cell-group>
        <div class="bt md20">
          <button @click="add()" class="btn">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Image as VanImage, ImagePreview } from "vant";

Vue.use(VanImage);
Vue.use(ImagePreview);
export default {
  data() {
    return {
      isPingjia: false,
      levels: [
        { id: "0", value: "", text: "满意", title: "" },
        { id: "1", value: "", text: "不满意", title: "" },
      ],
      xzlist: {
        level: "",
        content: "",
      },
      tsxq: {},
      bxxq: {},
      type: 1,
    };
  },
  mounted() {
    var id = this.$route.query.id;
    var type = this.$route.query.type || 1;
    this.type = type;
    this.isPingjia = this.$route.query.pj;
    if (type == 1) {
      this.$axios.get("/api/v1/complaint/" + id).then((res) => {
        this.tsxq = res;
      });
    } else {
      this.$axios.get("/api/v1/repair/" + id).then((res) => {
        this.bxxq = res;
      });
    }
  },
  methods: {
    changeType(e) {
      console.log(e);
    },
    preview(imgarr,type) {
      if(type){
        var arr = imgarr.map((obj) => {
          return this.imgIp + obj.webUrl;
        });
        ImagePreview({
          images: arr,
          onClose() {},
        });

      }else{
        var arr = imgarr.map((obj) => {
          return this.imgIp + obj;
        });
        ImagePreview({
          images: arr,
          onClose() {},
        });

      }
    },
    add() {
      if (this.xzlist.level == "") {
        this.$dialog({ message: "您未选择满意度" });
        return;
      }

      let data = new FormData();
      var jsonData = {};

      var postUrl = "";
      if (this.$route.query.type == 1) {
        (postUrl = "/api/v1/complaint/saveAssess"),
          (jsonData = {
            myd: this.xzlist.level,
            assessResult: this.xzlist.content,
            complaintId: this.$route.query.id,
          });
      } else {
        (postUrl = "/api/v1/repair/saveAssess"),
          (jsonData = {
            myd: this.xzlist.level,
            assessResult: this.xzlist.content,
            repairId: this.$route.query.id,
          });
      }
      for (let key in jsonData) {
        data.append(key, jsonData[key]);
      }
      this.$axios.post(postUrl, data).then((res) => {
        console.log(res);
        this.$dialog({ message: "提交成功" }).then(() => {
          this.$router.go(-1);
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
[v-cloak] {
  display: none;
}
.bt {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.md20 {
  margin-bottom: 20px;
}
.pjmain {
  height: calc(100% - 46px);
  width: 100%;
  background-color: #fff;
}
.shangchuan {
  line-height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 0px;
  overflow: hidden;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  border-bottom: #f4f4f4 1px solid;
  font-size: 16px;
}
.pj-dv {
  border-top: 1px solid #f4f4f4;
  margin-top: 20px;
}
.mt10 {
  margin-top: 10px;
}
.btn {
  margin-top: 30px;
  outline: none;
  border: none;
  border-radius: 10px;
  color: white !important;
  font-weight: 600;
  background: #28aff6;
  height: 40px;
  width: 70%;
  cursor: pointer;
}
.content {
  height: 100%;
  width: 92%;
  margin: 0 4% 0 4%;
  .pjxqtitle {
    padding: 10px 0;
    font-size: 18px;
    border-bottom: #f4f4f4 1px solid;
    p {
      font-size: 14px;
      color: #999999;
      margin: 0;
      line-height: 2rem;
    }
  }
  .bxqk {
    width: 100%;
    line-height: 25px;
    textarea {
      height: 125px;
      outline: none;
      border: #dddddd 1px solid;
      border-radius: 20px;
      margin-top: 10px;
      margin-bottom: 10px;
      text-indent: 2rem;
      color: #999999;
    }
    p {
      margin: 0;
      padding: 0;
    }
    .sx{
      font-size: 15px;
      color:#999;
    }
    .zhi{
      font-size: 15px;
 color:#000;
    }
  }
}
.daxing {
  display: flex;
  align-items: center;
  span {
    margin-right: 10px;
  }
}
.tijiao {
  margin-top: 30px;
  margin-bottom: 30px;
  outline: none;
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: 600;
  background: #28aff6;
  height: 40px;
  margin-left: 15%;
  width: 70%;
  cursor: pointer;
}
.dpj {
  height: 25px;
  top: calc(50% - 15px);
  border: 1px solid #00d2ff;
  color: #00d2ff;
  background-color: transparent;
  border-radius: 30px;
  font-size: 15px;
}
</style>